import React, { useState, useEffect } from "react";
import { Row, Col, Card, Image, Button } from "react-bootstrap";
import userImage from "../../assets/user.png";
import ApiService from "../../ApiService";

const PatientNameHeader = ({ patientId, patientName, patientPronune }) => {
  const [profilePic, setProfilePic] = useState(null);
  const [loading, setLoadingStatus] = useState(false);

  const fetchUserProfilePic = async () => {
    try {
      if (patientId) {
        const imageData = await ApiService.getUserProfilePicById(patientId);
        setProfilePic(imageData.data);
      }
    } catch (e) {
      setProfilePic(null);
      console.error("Error fething user's profile pic", e);
    } finally {
    }
  };
  useEffect(() => {
    fetchUserProfilePic();
  }, [patientId]);

  return (
    <div className="patientCard">
      <Row style={{ justifyContent: "center" }}>
        <Col>
          <div>
            <Image roundedCircle className="profile-pic" alt={"TBD user "} src={userImage} />
          </div>

          <p className="patientTag">{Array.isArray(patientPronune) ? patientPronune.join(", ") : patientPronune}</p>
          <span style={{ fontWeight: "normal", fontSize: "12px", textAlign: "center"}}>Preferred Name:</span>
          <h2 className="patientName">{patientName}</h2>

          <Button
            variant="info"
            className="messageBtn"
            onClick={() => {
              window.open(`/inbox?action=compose&pid=${patientId}`, "_blank");
            }}
          >
            Send Message
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default PatientNameHeader;
